import React from 'react';
import PropTypes from 'prop-types';
import { TooltipButton } from 'common/react/components/tooltip-button';
import { StatsTablePredictedCell } from './StatsTablePredictedCell';

const StatsTableBodyAwardCell = ({
    cellIndex,
    cellProps,
    valueWrapper,
    value,
    row,
    cell,
    isUpcoming,
    showPredictedData,
    isBrownlowTracker,
    primaryTooltipComponent,
    getCellId,
    getCellTitle,
    benchmark
}) => {
    const isBye = !isUpcoming && !value.played && value.actual === 'B';

    if (isBye) {
        return (
            <td className="stats-table__cell">
                <div className="stats-table__cell-predicted-wrapper">
                    <div className="stats-table__cell-inner-wrapper stats-table__cell-inner-wrapper--bye">
                        B
                    </div>
                    {isBrownlowTracker && (
                        <div className="stats-table__cell-predicted stats-table__cell-predicted--hidden"></div>
                    )}
                </div>
            </td>
        );
    }

    const showTooltip =
        primaryTooltipComponent &&
        !isUpcoming &&
        value.played &&
        value.actual !== 'B';

    return (
        <StatsTablePredictedCell
            key={cellIndex}
            cellProps={cellProps}
            condition={valueWrapper}
            value={value}
            row={row}
            isUpcoming={isUpcoming}
            showPredictedData={showPredictedData}
            tooltipButton={
                showTooltip ? (
                    <TooltipButton
                        id={getCellId(row, cell)}
                        title={getCellTitle(row, cell)}
                        hideArrow
                        noPadding
                        externalTooltip
                        showOnHover={false}
                        direction="below"
                        primaryTooltipContent={primaryTooltipComponent(
                            row,
                            cell,
                            benchmark
                        )}
                        classNames={{
                            component: 'stats-table__cell-button-wrapper',
                            button: 'stats-table__cell-button'
                        }}
                    >
                        {value.actual}
                    </TooltipButton>
                ) : null
            }
        />
    );
};

export default StatsTableBodyAwardCell;

StatsTableBodyAwardCell.propTypes = {
    cellIndex: PropTypes.number.isRequired,
    cellProps: PropTypes.object.isRequired,
    valueWrapper: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.shape({
            played: PropTypes.bool,
            actual: PropTypes.string
        })
    ]).isRequired,
    row: PropTypes.object.isRequired,
    cell: PropTypes.object.isRequired,
    isUpcoming: PropTypes.bool.isRequired,
    showPredictedData: PropTypes.bool,
    isBrownlowTracker: PropTypes.bool,
    primaryTooltipComponent: PropTypes.func,
    getCellId: PropTypes.func.isRequired,
    getCellTitle: PropTypes.func.isRequired,
    benchmark: PropTypes.string
};
